<template>
	<header class="b-header py-2 px-6">
    <div class="b-header__inner">
      <a href="#" class="b-header__logo-title">
        <div class="b-header__title">Lease Assistant</div>
      </a>
      <div class="b-header__right-part">
        <div class="b-header__right-part-lang mr-6">
          <div class="b-contract__text-warning mr-4 ">{{ roleName }}</div>
          <button class="b-btn b-btn_border_none px-1 b-header__right-part-lang-btn" :class="{'b-header__right-part-lang-btn_is_active': currentLang === 'ru'}" @click="setLang('ru')">RU</button>
<!--          Пока скрываем возможность переключения локали.-->
<!--          /-->
<!--          <button class="b-btn b-btn_border_none px-1 b-header__right-part-lang-btn" :class="{'b-header__right-part-lang-btn_is_active': currentLang === 'en'}" @click="setLang('en')">EN</button>-->
        </div>
        <button class="b-btn b-btn_type_empty px-0" @click="logout" type="submit">
          {{$t('CONTENT.Log_out')}}
        </button>
      </div>
    </div>
	</header>
</template>

<script>
  import {i18n} from "../../plugins/vue-i18n";
  import {mapGetters} from "vuex";

  export default {
  data() {
    return {
      currentLang: null,
      role: null,
    };
  },

  computed: {
    roleName() {
      const roleNames = {
        Auditor: `${this.$t('CONTENT.roles.auditor')}`,
        Operator: `${this.$t('CONTENT.roles.operator')}`,
        Admin: `${this.$t('CONTENT.roles.admin')}`,
      };
      return roleNames[this.role] || '';
    },
  },
  created() {
    this.currentLang = localStorage.getItem('language');
    this.role = localStorage.getItem('role');
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push({name: 'Login'});
    },
    setLang(lang) {
      localStorage.setItem('language', lang);
      this.currentLang = lang;
      i18n.locale = lang;
    }
  },
};
</script>
